//we are doing this so we can have a single document ready call
$(function(){